// extracted by mini-css-extract-plugin
export default {"widget":"SpotifyWidget_widget__hSJWE","slideIn":"SpotifyWidget_slideIn__GR5c6","closeButton":"SpotifyWidget_closeButton__KFF11"};